/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Fade from 'react-reveal/Fade';
import { useTranslation } from "react-i18next";

import CardImage from '../../components/card-image'
import { TitleOne, TextBodyOne, BorderText } from '../../components/text'
import OnDemandBody from '../../static/images/auto/background-service.svg'
import ic1 from '../../static/icons/service/auto/ic-1.svg'
import ic2 from '../../static/icons/service/auto/ic-2.svg'
import ic3 from '../../static/icons/service/auto/ic-3.svg'
import icCheck from '../../static/icons/ic-check-blue.svg'
import { DemandStyle, ListCleanStyle } from './service-list.styles'

const ListClean = ({ data = [] }) => {
  const { t } = useTranslation();

  return (
    <ListCleanStyle>
      <div className="title-service">{t('pageSalonMobilPangilan.part17')}</div>
      <div className="list">
        {data.map((item, key) => (
          <div className="list-row" key={key}>
            <div className="check">
              <img className="check" src={icCheck} alt="halojasa/check" />
            </div>
            <span>{item.name}</span>
          </div>
        ))}
      </div>
    </ListCleanStyle>
  )
}

const ServiceList = () => {
  const { t } = useTranslation();

  return (
    <DemandStyle>
      <img src={OnDemandBody} alt="halojasa/salon-mobil" />
      <Grid>
        <Row center="lg">
          <Col sm={12} xs={12} lg={8} className="bottom-column">
            <TitleOne display="block" align="center">
              {t('pageSalonMobilPangilan.part14')}
            </TitleOne>
            <div className="text-body-wrap">
              <TextBodyOne display="block" align="center">
                {t('pageSalonMobilPangilan.part15')}
              </TextBodyOne>
            </div>
            <div className="border-text-wrap">
              <Fade left>
                <BorderText background="linear-gradient(279deg, #ff7dcf, #5069bb)"></BorderText>
              </Fade>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} xs={12} md={4} lg={4} className="bottom-margin">
            <CardImage
              noFluid
              titleTop={true}
              image={ic1}
              styleImage={{ width: 252, height: 223.3 }}
              title={t('pageSalonMobilPangilan.part16')}
              desc={
                <ListClean
                  data={[
                    {
                      name: t('pageSalonMobilPangilan.part18')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part19')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part20')
                    }
                  ]}
                ></ListClean>
              }
            ></CardImage>
          </Col>
          <Col sm={12} xs={12} md={4} lg={4} className="bottom-margin">
            <CardImage
              noFluid
              titleTop={true}
              image={ic2}
              styleImage={{ width: 252, height: 223.3 }}
              title={t('pageSalonMobilPangilan.part21')}
              desc={
                <ListClean
                  data={[
                    {
                      name: t('pageSalonMobilPangilan.part22')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part23')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part24')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part25')
                    }
                  ]}
                ></ListClean>
              }
            ></CardImage>
          </Col>
          <Col sm={12} xs={12} md={4} lg={4} className="bottom-margin">
            <CardImage
              noFluid
              titleTop={true}
              image={ic3}
              title={t('pageSalonMobilPangilan.part26')}
              styleImage={{ width: 252, height: 223.3 }}
              desc={
                <ListClean
                  data={[
                    {
                      name: t('pageSalonMobilPangilan.part27')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part28')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part29')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part30')
                    },
                    {
                      name: t('pageSalonMobilPangilan.part31')
                    }
                  ]}
                ></ListClean>
              }
            ></CardImage>
          </Col>
        </Row>
      </Grid>
    </DemandStyle>
  )
}

export default ServiceList
